import { useUnit } from 'effector-react';
import { $openedId } from '../../models/detail-sdui-opened-id';
import { $getListPending, RelatedTicketsGate } from '../../models/related-tickets';
import { Header } from './header';
import * as Styled from './styled';
import { Table } from './table';

export const RetaledTicketsTab = () => {
  const [openedId, getListPending] = useUnit([$openedId, $getListPending]);

  return (
    <>
      <RelatedTicketsGate id={String(openedId!)} />

      <Header />

      <Styled.Body><Table isLoading={getListPending} /></Styled.Body>
    </>
  );
};
